import { TrailerType } from '../../../types/trailer';

export const DEFAULT_TRAILER = TrailerType.REFRIGERATOR_WIDE;
